<h2 mat-dialog-title>Edit track</h2>
<mat-dialog-content>

  <app-edit-track-component
    [genresList]="data.genresList"
    [subgenresList]="data.subgenresList"
    [track]="data.track"
    [(ngModel)]="track"
  ></app-edit-track-component>

<!--  <app-edit-track-component-->
<!--    [genresList]="data.genresList"-->
<!--    [subgenresList]="data.subgenresList"-->
<!--    [track]="data.track"-->
<!--    [artistsList]="data.artistsList"-->
<!--    [(ngModel)]="track2"-->
<!--  ></app-edit-track-component>-->

</mat-dialog-content>
<mat-dialog-actions>
  <button matButton (click)="onNoClick()">Cancel</button>
  <button matButton (click)="save()" cdkFocusInitial>Save</button>
</mat-dialog-actions>
